// Spanish dictionary — lazy-loaded on demand via AppContext (keeps the entry
// bundle lean for English visitors). Mirrors the `en` shape in ./i18n.js.
export const es = {
    brand: "ChambaNow",
    common: {
      showOriginal: "Ver original",
      showTranslation: "Ver traducción",
    },
    languages: {
      title: "IDIOMAS QUE HABLA",
      subtitle: "Toca todos los que hablas",
      filterLabel: "Habla",
      filterAny: "Cualquier idioma",
      en: "Inglés",
      es: "Español",
      zh: "Mandarín",
      tl: "Tagalo",
      vi: "Vietnamita",
      ar: "Árabe",
      fr: "Francés",
      ht: "Creol Haitiano",
      ko: "Coreano",
      ru: "Ruso",
      pt: "Portugués",
      pl: "Polaco",
      it: "Italiano",
      hi: "Hindi",
      pa: "Punyabí",
      ur: "Urdu",
      yue: "Cantonés",
      ja: "Japonés",
      de: "Alemán",
      fa: "Farsi",
      gu: "Guyaratí",
      he: "Hebreo",
      hy: "Armenio",
      bn: "Bengalí",
      el: "Griego",
    },
    nav: { search: "Buscar Trabajadores", post: "Publicar Perfil", dashboard: "Panel", login: "Iniciar Sesión", signup: "Registrarse", logout: "Salir", inbox: "Mensajes", profile: "Mi Perfil", jobs: "Empleos", postJob: "Publicar Empleo", myJobs: "Panel de Empleos", myApplications: "Mis Solicitudes", pricing: "Planes", plans: "Planes y Precios", refer: "Recomienda y Gana", account: "Mi Cuenta" },
    hero: {
      eyebrow: "MERCADO BILINGÜE DE TRABAJADORES — EL CHAT SE TRADUCE SOLO",
      title: "DISEÑADO PARA CONTRATAR TRABAJADORES DE OFICIO",
      titleAccent: "RÁPIDO.",
      subheading: "Diseñado para contratar trabajadores de labor y oficio — publica un trabajo gratis y conecta con profesionales locales verificados hoy.",
      subheadingVariants: [
        "Contrata trabajadores de labor y oficio para cualquier trabajo — por horas o tiempo completo. ChambaNow está hecho para ti.",
        "Desde jornaleros hasta oficios especializados, contrata a los trabajadores que hacen el trabajo — rápido, local y bilingüe.",
        "Diseñado para contratar trabajadores de labor y oficio — publica un trabajo gratis y conecta con profesionales locales verificados hoy.",
      ],
      subtitle: "Para contratistas y pequeños negocios de oficio que necesitan ayuda local confiable — publica un trabajo, revisa trabajadores verificados y chatea en tu propio idioma. Cada mensaje se traduce al instante entre inglés y español. Sin intermediarios, sin comisiones de agencia.",
      signupLaborer: "Únete como Trabajador",
      signupHirer: "Únete como Contratante",
      signupLaborerNote: "Gratis — encuentra trabajo hoy",
      signupHirerNote: "Busca y contacta trabajadores",
      stat1Value: "2min",
      stat1Label: "Tiempo prom. para conectar",
      stat2Value: "Gratis",
      stat2Label: "Publica tus habilidades",
      stat3Value: "Local",
      stat3Label: "Trabajadores cerca de ti",
      howItWorksLink: "Cómo funciona",
      getStarted: "Empezar",
      alreadyAccount: "¿Ya tienes cuenta?",
      signIn: "Iniciar Sesión",
    },
    how: {
      title: "CÓMO FUNCIONA",
      laborer: {
        title: "PARA TRABAJADORES",
        desc: "Gratis por siempre. Publica tus habilidades, disponibilidad y tarifa. Contrátate el mismo día.",
        items: ["Crea tu perfil en 2 minutos", "Agrega habilidades, código postal, tarifa", "Activa tu disponibilidad en vivo", "Busca y aplica a miles de ofertas de trabajo", "Recibe mensajes de contratantes en la app"],
      },
      hirer: {
        title: "PARA CONTRATANTES",
        desc: "Busca trabajadores verificados. Filtra por habilidad, zona, tarifa. Envía mensajes en la app.",
        items: ["Regístrate en 30 segundos", "Dos formas de contratar: pase instantáneo o publicaciones ilimitadas", "Filtra por habilidad, zona, tarifa, transporte", "Envía mensajes directos en la app", "Acuerda el transporte directamente"],
      },
    },
    skills: { title: "HABILIDADES POPULARES", subtitle: "De construcción a jardinería. Si es trabajo manual, está en ChambaNow." },
    hireWays: {
      title: "DOS FORMAS DE CONTRATAR",
      subtitle: "Elige el camino que se ajuste a tu proyecto — ayuda puntual o publicaciones ilimitadas.",
      instantTitle: "CONTRATACIÓN INSTANTÁNEA",
      instantDesc: "Busca trabajadores disponibles ahora mismo. Mándales mensaje directo. Negocia la tarifa. Recibe ayuda hoy.",
      instantItems: ["Mapa de disponibilidad en vivo", "Pago por uso (sin suscripción)", "Chat directo en la app", "Haz ofertas al momento"],
      instantCta: "Ver Planes",
      plusTitle: "PUBLICA EMPLEOS ILIMITADOS",
      plusBadge: "HIRER PLUS",
      plusDesc: "Publica vacantes ilimitadas — jornal, corto plazo, contrato, temp-to-hire, por día, permanente y tiempo completo. Todas las industrias.",
      plusItems: [
        "Publicaciones ilimitadas",
        "Formulario de aplicación personalizado por empleo",
        "Recibe currículums y cartas",
        "Mensajes ilimitados a trabajadores (sin pase necesario)",
      ],
      plusCta: "Ver Precios",
    },
    finalCta: { title: "¿LISTO PARA TRABAJAR?", subtitle: "Únete a cientos de trabajadores y contratantes conectando en ChambaNow.", btn: "Empezar" },
    auth: {
      loginTitle: "INICIAR SESIÓN", signupTitle: "CREAR CUENTA",
      email: "Correo", password: "Contraseña", name: "Nombre Completo",
      role: "Soy...", roleLaborer: "Trabajador (busco trabajo)", roleHirer: "Contratante (busco contratar)",
      workerSafety: "ChambaNow respeta tu privacidad y nunca vende ni comparte tus datos.",
      submitLogin: "INICIAR SESIÓN", submitSignup: "CREAR CUENTA",
      forgotPassword: "¿Olvidaste tu contraseña?",
      forgotTitle: "RESTABLECER CONTRASEÑA",
      forgotIntro: "Ingresa el correo de tu cuenta y te enviaremos un enlace para restablecer tu contraseña.",
      forgotSubmit: "ENVIAR ENLACE",
      forgotSent: "Si existe una cuenta con ese correo, te enviamos un enlace para restablecer la contraseña. Revisa tu bandeja (y el spam).",
      backToLogin: "Volver a iniciar sesión",
      resetTitle: "ELIGE UNA NUEVA CONTRASEÑA",
      resetIntro: "Ingresa una nueva contraseña para tu cuenta.",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar nueva contraseña",
      resetSubmit: "RESTABLECER CONTRASEÑA",
      resetSuccess: "Contraseña actualizada. Ya puedes iniciar sesión.",
      resetMismatch: "Las contraseñas no coinciden.",
      resetTooShort: "La contraseña debe tener al menos 8 caracteres.",
      resetInvalidLink: "Este enlace es inválido o ha expirado. Solicita uno nuevo.",
      orGoogle: "o continúa con Google", google: "Continuar con Google",
      noAccount: "¿No tienes cuenta?", hasAccount: "¿Ya tienes cuenta?",
      switchSignup: "Regístrate", switchLogin: "Inicia sesión",
      referralBannerValid: "🎁 Te invitó {name} — recibirás ${amount} de descuento en tu primera suscripción Plus.",
      referralBannerInvalid: "Ese código de referido no es válido, pero puedes registrarte de todos modos.",
      agreePrefix: "He leído y acepto los",
      agreeTerms: "Términos de Uso",
      agreeAnd: "y la",
      agreePrivacy: "Política de Privacidad",
      agreeRequired: "Debes aceptar los Términos de Uso y la Política de Privacidad para crear una cuenta.",
    },
    referral: {
      navLink: "Refiere y Gana",
      pageTitle: "REFIERE AMIGOS, GANA $10 EN EFECTIVO",
      subtitle: "Comparte tu enlace. Cuando un amigo se suscribe a Hirer Plus, tú ganas $10 y él recibe $5 de descuento. Cobra por PayPal, Venmo o Zelle al llegar a $20.",
      yourCodeLabel: "TU CÓDIGO DE REFERIDO",
      yourLinkLabel: "TU ENLACE PARA COMPARTIR",
      copyCode: "Copiar código",
      copyLink: "Copiar enlace",
      copied: "¡Copiado!",
      shareTitle: "ChambaNow — encuentra trabajadores rápido",
      shareText: "Únete a mí en ChambaNow. Regístrate con mi enlace y obtén $5 de descuento en tu primera suscripción Hirer Plus:",
      shareWhatsApp: "WhatsApp",
      shareSms: "SMS",
      shareEmail: "Correo",
      balanceTitle: "TUS GANANCIAS",
      balanceTotal: "Total ganado",
      balanceAvailable: "Disponible para cobrar",
      balancePaidOut: "Ya pagado",
      successfulReferrals: "Referidos exitosos",
      pendingReferrals: "Pendientes (registrados, aún no compran Plus)",
      payoutBtn: "SOLICITAR PAGO",
      payoutLockedBtn: "Faltan ${remaining} para cobrar",
      payoutPendingBadge: "Pago pendiente",
      payoutModalTitle: "SOLICITAR PAGO",
      payoutMethodLabel: "Método de pago",
      payoutPayPal: "PayPal",
      payoutVenmo: "Venmo",
      payoutZelle: "Zelle",
      payoutDestPayPal: "Correo de PayPal",
      payoutDestVenmo: "Usuario o teléfono de Venmo",
      payoutDestZelle: "Correo o teléfono de Zelle",
      payoutConfirm: "SOLICITAR ${amount}",
      payoutCancel: "Cancelar",
      payoutRequested: "¡Pago solicitado! Lo enviaremos en 3-5 días hábiles.",
      historyTitle: "HISTORIAL DE REFERIDOS",
      historyEmpty: "Aún no hay referidos. ¡Comparte tu enlace para ganar $10 por amigo!",
      historyHeaderFriend: "Amigo",
      historyHeaderStatus: "Estado",
      historyHeaderDate: "Fecha",
      historyHeaderAmount: "Monto",
      statusPending: "Registrado",
      statusCredited: "Ganado",
      statusPaidOut: "Pagado",
      howItWorksTitle: "CÓMO FUNCIONA",
      step1: "Comparte tu enlace con amigos, familia, contratistas — cualquiera que contrate trabajadores.",
      step2: "Se registran y se suscriben a Hirer Plus ($29.99/mes). Ahorran $5.",
      step3: "Tú ganas $10. Cobra por PayPal, Venmo o Zelle al llegar a $20.",
      step4: "Sin límite. Sin caducidad. Sigue ganando para siempre.",
      materialsTitle: "MATERIALES DE MARKETING",
      materialsSubtitle: "Descarga volantes, cupones y publicaciones listos para imprimir — con tu código QR ya incluido. Cada escaneo lleva a la gente a tu enlace de registro.",
      materialsQRPreview: "TU CÓDIGO QR PERSONAL",
      materialsQRHint: "Todos los materiales de abajo llevan este mismo código QR — apuntando a tu enlace de referido único.",
      materialsDownloadPng: "Descargar PNG",
      materialsShare: "Compartir",
      materialsShareFallback: "Imagen guardada en tu dispositivo — adjúntala a tu publicación.",
      materialsView: "Ver tamaño real",
      material1Label: "Historia de Instagram",
      material1Use: "Publica en Instagram, TikTok, Facebook Stories o Estado de WhatsApp.",
      material2Label: "Publicación cuadrada",
      material2Use: "Perfecta para el feed de Instagram, LinkedIn o Facebook.",
      material3Label: "Volante con cupones (8 tiras)",
      material3Use: "Imprime en papel carta. Pega en carteleras — cada tira tiene su propio QR.",
      material4Label: "Volante vertical",
      material4Use: "Imprime para cafeterías, ferreterías, centros comunitarios, lavanderías.",
      material5Label: "Banner horizontal",
      material5Use: "Úsalo como encabezado en grupos de chat, firmas de correo o portada de Facebook.",
      spreadTitle: "CÓMO CORRER LA VOZ",
      spreadTip1Title: "Imprime y pega localmente",
      spreadTip1Body: "Pregunta en ferreterías, cafeterías, lavanderías y centros comunitarios si puedes poner un volante en su cartelera. La plantilla con cupones está diseñada para esto.",
      spreadTip2Title: "Publica en redes sociales",
      spreadTip2Body: "Comparte la publicación cuadrada en grupos de Facebook para contratistas, propietarios o inmigrantes de tu ciudad. Usa la historia vertical en Instagram/TikTok.",
      spreadTip3Title: "Envíalo por texto",
      spreadTip3Body: "Envía el banner + tu enlace en grupos de chat con compañeros de oficio, vecinos y familia. Un solo mensaje puede ser $10.",
      spreadTip4Title: "Corre la voz en persona",
      spreadTip4Body: "Entrega un volante a contratantes en el estacionamiento, Home Depot o en la obra. Cualquiera que escanee y se registre recibe $5 de descuento — y tú ganas $10.",
    },
    laborerForm: {
      title: "TU PERFIL DE TRABAJADOR",
      subtitle: "Llénalo una vez. Mantente visible para contratantes en tu zona.",
      liveTitle: "MODO TRABAJO INSTANTÁNEO",
      liveSubtitle: "Contrátate al instante — aparece en búsquedas de 'Contratar Ahora' y chatea con contratantes en tiempo real. Para trabajo del mismo día.",
      jobBoardTitle: "BOLSA DE EMPLEO",
      jobBoardSubtitle: "Busca empleos publicados (jornada, contrato, temporal, permanente, por día). Aplica con tu perfil — el contratante revisa tu solicitud antes de chatear.",
      jobBoardBrowse: "VER EMPLEOS",
      jobBoardApplications: "MIS SOLICITUDES",
      liveOn: "ESTOY DISPONIBLE AHORA",
      liveOff: "APAGADO — NO DISPONIBLE",
      liveHintOn: "Aparecerás en búsquedas de 'Contratar Ahora'. Toca de nuevo para apagar.",
      liveHintOff: "Los contratantes no te verán en 'Contratar Ahora' hasta que actives esto.",
      liveProfileFirst: "Guarda tu perfil abajo primero, luego puedes activar tu disponibilidad.",
      liveExpiresIn: "Apagado en",
      liveAutoOff: "(se apaga sola después de 8h)",
      phone: "Número de Teléfono", skills: "Habilidades (selecciona todas las que apliquen)",
      rateMin: "Tarifa Mín. por Hora ($)", rateMax: "Tarifa Máx. por Hora ($)",
      zip: "Código Postal", city: "Ciudad",
      transport: "Tengo mi propio transporte",
      available: "Estoy disponible para trabajar",
      jobAlerts: "Avísame de nuevos trabajos cerca de mí",
      jobAlertsHint: "Recibe un correo cuando se publique un trabajo que coincida con tus habilidades a menos de 50 millas.",
      dates: "Fechas Futuras Disponibles",
      datesHint: "Toca las fechas en que estarás libre. Elige una franja horaria para cada día.",
      presetsLabel: "Añadir rápido",
      presetNext7: "Próximos 7 días",
      presetWeekdays: "Días de semana",
      presetWeekends: "Fines de semana",
      presetClear: "Borrar todo",
      dashBrowseCta: "Ver empleos cerca de ti",
      dashBrowseSub: "Mira empleos pagados publicados cerca de ti y postúlate con un toque.",
      timeMorning: "Mañana",
      timeAfternoon: "Tarde",
      timeEvening: "Noche",
      timeSlotsLabel: "Horarios",
      noDatesPicked: "Aún no has elegido fechas — toca una fecha en el calendario arriba.",
      bio: "Biografía Corta (opcional)", bioNoContact: "Sin teléfonos, correos ni enlaces — los contratantes te escriben por ChambaNow.", years: "Años de Experiencia",
      resumeTitle: "CURRÍCULUM / CERTIFICACIONES",
      resumeSubtitle: "Sube un documento para que los contratantes vean tu experiencia rápidamente.",
      resumeNoContact: "Importante: NO incluyas tu número de teléfono ni correo. Solo experiencia, historial laboral, educación y certificaciones / licencias.",
      resumeHint: "Solo PDF · Máx 5 MB",
      portfolioTitle: "PORTAFOLIO DE TRABAJO",
      portfolioSubtitle: "Muestra fotos de tu trabajo — los contratantes con plan las ven en tu perfil.",
      portfolioReviewNote: "Las fotos son revisadas por nuestro equipo antes de que los contratantes puedan verlas.",
      portfolioAdd: "Agregar fotos",
      portfolioUploading: "Subiendo…",
      portfolioPending: "En revisión",
      portfolioApproved: "Aprobada",
      portfolioMax: "Puedes subir hasta {n} fotos.",
      portfolioBadType: "Elige una imagen (JPG o PNG).",
      portfolioTooBig: "Imagen muy grande (máx 5 MB).",
      portfolioRemoveConfirm: "¿Eliminar esta foto?",
      portfolioRemoved: "Foto eliminada",
      portfolioUploaded: "Foto subida — en revisión",
      portfolioEmpty: "Aún no hay fotos. Agrega algunas para destacar.",
      portfolioCover: "Portada",
      portfolioReorderHint: "Arrastra las fotos para reordenar — tu primera foto encabeza tu perfil.",
      portfolioRejectedTitle: "Requiere atención",
      portfolioRejected: "Rechazada",
      portfolioRejectedToast: "Una foto del portafolio fue rechazada",
      portfolioCaptionPlaceholder: "Agrega una descripción (opcional)",
      resumeCurrent: "Currículum actual",
      resumeUpload: "SUBIR CURRÍCULUM",
      resumeReplace: "REEMPLAZAR",
      resumeRemove: "QUITAR",
      resumeUploading: "Subiendo…",
      resumeUploaded: "Currículum subido — en revisión.",
      resumeStatusPending: "En revisión",
      resumeStatusApproved: "Aprobado",
      resumeStatusRejected: "No aprobado",
      resumePendingNote: "Tu currículum está en revisión — los contratantes no lo verán hasta que se apruebe.",
      resumeRejectedNote: "Tu currículum no fue aprobado. Por favor reemplázalo por uno nuevo.",
      resumeRemoved: "Currículum eliminado.",
      resumeRemoveConfirm: "¿Quitar tu currículum?",
      resumeTooBig: "Archivo muy grande. Máx 5 MB.",
      resumeBadType: "El currículum debe ser PDF. Vuelve a guardarlo como PDF e inténtalo de nuevo.",
      save: "GUARDAR PERFIL", saved: "¡Perfil guardado!",
      welcomeTitle: "BIENVENIDO — CREA TU PERFIL",
      welcomeBody: "Llena el formulario para que los contratantes te encuentren. Toma unos 2 minutos. Puedes activar la disponibilidad en vivo cuando estés listo para trabajar.",
      welcomeSteps: ["Agrega tu teléfono, habilidades y código postal", "Define tu rango de tarifa por hora", "Guarda tu perfil", "Toca 'EN VIVO' cuando estés listo para trabajar"],
    },
    search: {
      title: "ENCONTRAR TRABAJADORES",
      distance: "Distancia",
      distanceAny: "Cualquier distancia",
      dist10: "Hasta 10 millas",
      dist25: "Hasta 25 millas",
      dist50: "Hasta 50 millas",
      dist100: "Hasta 100 millas",
      dashPostJob: "Publicar Empleo",
      dashPostJobDesc: "Llega a trabajadores locales ahora",
      dashReview: "Revisar Postulantes",
      dashReviewDesc: "Mira quién aplicó a tus empleos",
      dashFind: "Buscar Trabajadores",
      dashFindDesc: "Busca y contacta trabajadores disponibles",
      jobsPagePromoTag: "HIRER PLUS",
      jobsPagePromoTitle: "Crea la página de Trabajos de tu empresa",
      jobsPagePromoDesc: "Una página con tu marca, logo, colores y todos tus trabajos abiertos — configúrala en 3 pasos rápidos.",
      jobsPagePromoCta: "Configurar",
      jobsPagePromoLearn: "Saber más",
      filters: "FILTROS",
      modeNow: "CONTRATAR AHORA",
      modeLater: "CONTRATAR DESPUÉS",
      modeNowHint: "Solo trabajadores disponibles ahora",
      modeLaterHint: "Elige una fecha futura",
      availableTitle: "Buscar trabajadores disponibles",
      availableHint: "Trabajadores disponibles ahora cerca de ti",
      pickDate: "Elige una fecha",
      skill: "Habilidad", any: "Cualquiera",
      zip: "Código Postal", date: "Fecha",
      viewList: "Lista", viewMap: "Mapa", mapLoading: "Cargando trabajadores, por favor espera…", viewProfile: "Ver perfil", viewPortfolio: "Ver portafolio",
      location: "Ciudad, Estado o Código Postal", locationPlaceholder: "Ciudad, Estado o Código Postal",
      rateMin: "Tarifa Mín.", rateMax: "Tarifa Máx.", messageCta: "Mensaje",
      transport: "Tiene Transporte Propio",
      timeOfDay: "Hora del Día",
      timeMorning: "Mañana",
      timeAfternoon: "Tarde",
      timeEvening: "Noche",
      anyTime: "Cualquier hora",
      verifiedOnly: "Solo trabajadores verificados",
      includeOffline: "Incluir trabajadores desconectados",
      verifiedBadge: "VERIFICADO",
      photosBadge: "FOTOS",
      apply: "APLICAR FILTROS", reset: "REINICIAR",
      results: "RESULTADOS", noResults: "Aún no hay trabajadores que coincidan con tus filtros.",
      locked: "Obtén Acceso de Contratante para enviar mensajes",
      unlockBtn: "CONTRATAR A ESTE TRABAJADOR",
      contact: "Contacto", phone: "Teléfono", email: "Correo",
      contactBtn: "MENSAJE",
      privateNote: "El teléfono y correo se mantienen privados — todo contacto es dentro de la app.",
      yearsExp: "años exp", rate: "Tarifa", transport2: "Transporte",
      ownTransport: "Propio", needsPickup: "Necesita recogida",
      liveDot: "DISPONIBLE AHORA",
      milesAway: "mi",
      viewResume: "VER CURRÍCULUM",
    },
    pass: {
      active: "PASE DE TRABAJO ACTIVO",
      planLabel: "HIRER PLUS",
      subActiveBody: "Suscripción activa",
      getPassBody: "Obtén un Pase de Trabajo de 48 Horas",
      dayUnit: "día",
      daysUnit: "días",
      expires: "Expira en",
      inactive: "SIN PASE ACTIVO",
      buyTitle: "OBTÉN EL PASE DE TRABAJO DE 48 HORAS",
      buyDesc: "48 horas de acceso para contratar en un solo trabajo — busca, contacta y revisa postulantes. Extiéndelo antes de que termine.",
      buyBtn: "OBTENER ACCESO",
      postFreeLabel: "EMPIEZA",
      postFreeTitle: "PUBLICA TRABAJOS ILIMITADOS — GRATIS POR 30 DÍAS",
      postFreeDesc: "Comienza tu prueba gratis de 30 días de Hirer Plus — cancela cuando quieras. Publica trabajos ilimitados.",
      postFreeBtn: "Publica un trabajo gratis",
      postJobBtn: "Publica un trabajo",
      plansTitle: "¿Listo para contratar?",
      plansDesc: "Mira las opciones de Pase de Trabajo de 48 Horas y Hirer Plus para ver postulantes y enviar mensajes.",
      plansBtn: "Ver planes y precios",
      processing: "Procesando pago...",
    },
    success: { title: "PAGO EXITOSO", subtitle: "Tu Pase de Trabajo de 48 Horas está activo. Empieza a contratar ahora.", goSearch: "EMPEZAR A BUSCAR" },
    chat: {
      inboxTitle: "MENSAJES",
      emptyInbox: "Aún no tienes conversaciones.",
      startNew: "Busca trabajadores para iniciar un chat.",
      placeholder: "Escribe tu mensaje…",
      send: "ENVIAR",
      backToInbox: "ATRÁS",
      viewProfile: "Ver perfil del trabajador",
      screeningTitle: "Respuestas de la solicitud",
      noAnswer: "Sin respuesta",
      thread: "CONVERSACIÓN",
      unread: "nuevo",
      youNeedPass: "Necesitas un Pase activo para enviar mensajes.",
      passExpired: "Pase expirado — renueva para seguir chateando.",
      privacyNote: "Tu teléfono y correo nunca se comparten. La otra persona recibe una notificación cuando envías un mensaje.",
      enablePush: "Recibe avisos al instante cuando alguien te escriba",
      enablePushBtn: "ACTIVAR NOTIFICACIONES",
      pushEnabled: "Notificaciones activadas",
      pushDenied: "Notificaciones bloqueadas en el navegador",
      makeOffer: "HACER OFERTA",
      offerTitle: "ENVIAR OFERTA",
      offerRateType: "Tipo de Tarifa",
      offerHourly: "Tarifa por Hora",
      offerJob: "Tarifa Total",
      offerRate: "Monto ($)",
      offerLocation: "Lugar del Trabajo",
      offerDuration: "Duración Estimada (horas)",
      offerTransport: "Yo proveo el transporte",
      offerNotes: "Notas (opcional)",
      offerSubmit: "ENVIAR OFERTA",
      offerSent: "Oferta enviada",
      offerAccept: "ACEPTAR",
      offerReject: "RECHAZAR",
      offerAccepted: "OFERTA ACEPTADA",
      offerRejected: "OFERTA RECHAZADA",
      offerPending: "OFERTA PENDIENTE",
      offerBadge: "OFERTA",
      offerStatusLabel: "Estado",
      reLabel: "Re:",
      viewJob: "Ver trabajo",
      lockedTitle: "Conversaciones bloqueadas",
      lockedDesc: "Tu Pase de Contratación o Hirer Plus terminó. Reactívalo para ver y continuar tus conversaciones — no se borra nada.",
      reactivate: "VER PLANES",
      jobConfirmed: "TRABAJO CONFIRMADO",
      jobConfirmedDesc: "Oferta aceptada. Coordinen la hora de llegada y los detalles finales en el chat de abajo.",
      markComplete: "MARCAR TRABAJO COMPLETADO",
      markCompleteConfirm: "¿Marcar este trabajo como completado? Ambos podrán dejar una reseña.",
      jobCompleted: "TRABAJO COMPLETADO",
      leaveReview: "DEJAR UNA RESEÑA",
      rateTitle: "CALIFICA TU EXPERIENCIA",
      rateWorker: "¿Cómo fue este trabajador?",
      rateHirer: "¿Cómo fue trabajar con este contratante?",
      reviewCommentPlaceholder: "Agrega un comentario (opcional)…",
      reviewSubmit: "ENVIAR RESEÑA",
      reviewSubmitted: "Reseña enviada — ¡gracias!",
      youRated: "Calificaste",
      completeFailed: "No se pudo marcar como completado",
      reviewFailed: "No se pudo enviar la reseña",
    },
    reviews: {
      newTag: "Nuevo",
      reviewsLabel: "reseñas",
      reviewsTitle: "Reseñas",
      ratingHiddenNote: "Las calificaciones aparecen con 5+ reseñas",
    },
    footer: { tagline: "El mercado virtual de trabajadores.", rights: "Todos los derechos reservados.", contact: "Contacto", press: "Prensa y Medios", hiringIn: "CONTRATANDO AHORA EN", hireIn: "CONTRATAR TRABAJADORES EN", moreCities: "Todas las ciudades", terms: "Términos de Uso", privacy: "Política de Privacidad" },
    landing: {
      birthdayRibbonBold: "Feliz 250º Cumpleaños, América.",
      birthdayRibbon: "Lee nuestra carta a los trabajadores, inmigrantes y soñadores que construyeron este país.",
      birthdayRibbonCta: "Leer la carta",
      value: {
        eyebrow: "UNA PLATAFORMA. AMBOS LADOS.",
        title: "Todo lo que obtienes",
        subtitle: "Hecho para quienes hacen el trabajo — y para quienes lo necesitan. Sin intermediarios, sin comisiones de agencia.",
        workersTag: "PARA TRABAJADORES",
        workersTitle: "Consigue trabajo, cobra",
        workersFree: "100% GRATIS — PARA SIEMPRE",
        workers: [
          "Publica tu disponibilidad y que te encuentren contratantes cercanos",
          "Tu propio enlace de perfil para conseguir más trabajo",
          "Traducción de chat en tiempo real — habla con cualquier contratante en tu idioma",
          "Aplica a trabajos ilimitados, de corto y largo plazo",
          "Fija tus propias tarifas y habilidades — sin comisiones",
        ],
        workersCta: "Únete gratis como trabajador",
        hirersTag: "PARA CONTRATANTES",
        hirersTitle: "Contrata en minutos",
        hirersFree: "PRIMER MES GRATIS",
        hirers: [
          "Publica trabajos ilimitados gratis por 30 días — cancela cuando quieras",
          "Tu propia página de Trabajos para compartir e insertar en tu sitio",
          "Llega a trabajadores disponibles por habilidad, ciudad y radio",
          "Escribe y gestiona a todos los postulantes en un solo lugar",
          "Traducción en tiempo real integrada en cada conversación",
        ],
        hirersCta: "Empieza a contratar",
      },
    },
    translation: {
      eyebrow: "TRADUCCIÓN EN VIVO — GRATIS",
      title: "ESCRIBE EN TU IDIOMA.",
      titleAccent: "ELLOS LEEN EN EL SUYO.",
      subtitle: "Chatea naturalmente con cualquier trabajador o contratante en ChambaNow. Los mensajes se traducen automáticamente al enviarse — sin copiar, sin pegar, sin malos entendidos.",
      bullets: [
        "Inglés ↔ Español (más idiomas próximamente)",
        "Original + traducción lado a lado",
        "Funciona para negociar trabajos, dar instrucciones de seguridad y direcciones",
        "Sin configuración — simplemente funciona",
      ],
      cta: "Prueba traducción en vivo gratis",
      mockLive: "CHAT EN VIVO",
      mockJobId: "TRABAJO #4821",
      workerName: "José R.",
      workerTranslated: "Yes, I have my own tools and transport. I can be there in 30 minutes. What time do we start?",
      hirerName: "Mike H.",
      hirerTranslated: "Perfecto — llegaré a la dirección en 30 minutos también. Trae gafas de seguridad. Tarifa: $28/hr, en efectivo al final del día.",
      mockComposer: "Mensaje traducido mientras escribes…",
      mockFooter: "TRADUCIDO EN TIEMPO REAL · IMPULSADO POR CHAMBANOW",
    },
    referAndEarn: {
      eyebrow: "CHAMBANOW · RECOMIENDA Y GANA",
      h1Line1: "COMPARTE CHAMBANOW.",
      h1Line2: "GANA $10 EN EFECTIVO.",
      subtitle: "Invita amigos, contratistas y vecinos. Cuando se suscriban a Hirer Plus, tú recibes $10 — y ellos reciben $5 de descuento. Retira via PayPal, Venmo o Zelle cuando llegues a $20.",
      ctaLoggedOut: "Regístrate y obtén tu enlace",
      ctaLoggedIn: "Obtén tu enlace de referido",
      ctaSignin: "Ya tengo cuenta",
      freeToJoin: "Gratis unirse. Sin límite de referidos. Retira cuando pases de $20.",
      stat1Value: "$10", stat1Label: "POR REFERIDO",
      stat2Value: "$5", stat2Label: "DE DESCUENTO PARA TU AMIGO",
      stat3Value: "$20", stat3Label: "RETIRO MÍNIMO",
      howTitle: "CÓMO FUNCIONA",
      howSubtitle: "Tres pasos, dinero en tu cuenta.",
      step1: { title: "OBTÉN TU ENLACE", body: "Inicia sesión, abre tu panel Recomienda y Gana, y copia tu enlace único de referido." },
      step2: { title: "COMPÁRTELO", body: "SMS, correo, WhatsApp, Instagram, TikTok, en la obra, en la iglesia — donde estén tus contactos." },
      step3: { title: "COBRA", body: "Cada amigo que se suscriba a Hirer Plus añade $10 a tu saldo. Retira via PayPal, Venmo o Zelle desde $20." },
      rewardsTitle: "LO QUE RECIBEN AMBOS",
      rewardYouLabel: "TÚ GANAS",
      rewardYouBody: "Por cada amigo que se convierta en suscriptor Hirer Plus usando tu enlace.",
      rewardYouBullets: [
        "Se acredita al instante cuando se suscriben",
        "Se acumula — sin límite, refiere a cuantos quieras",
        "Retira via PayPal, Venmo o Zelle desde $20",
      ],
      rewardFriendLabel: "TU AMIGO RECIBE",
      rewardFriendBody: "$5 de descuento en su primer mes de Hirer Plus al usar tu enlace.",
      rewardFriendBullets: [
        "Automático — sin código de cupón",
        "Aplicado en el checkout de la primera suscripción",
        "Aceptarlo no les cuesta nada",
      ],
      faqTitle: "PREGUNTAS",
      faqs: [
        { q: "¿Quién puede referir?", a: "Cualquiera con cuenta en ChambaNow — trabajador o contratante. No tienes que ser suscriptor de pago." },
        { q: "¿Cómo me pagan?", a: "Cuando tu saldo llegue a $20, solicita el retiro desde tu panel Recomienda y Gana. Enviamos por PayPal, Venmo o Zelle." },
        { q: "¿Cuándo se acredita?", a: "En cuanto se procese el primer pago Hirer Plus de tu amigo. Los créditos aparecen en tu panel al instante." },
        { q: "¿Hay límite?", a: "Sin límite. Refiere a 5, 50 o 500 personas — cada una te da $10." },
        { q: "¿Y si mi amigo cancela?", a: "Conservas los créditos ganados. Los meses futuros de esa persona no añaden más." },
        { q: "¿Puedo referirme a mí mismo?", a: "No — el amigo debe ser otra persona con otro correo y otro método de pago. Cuentas duplicadas se eliminan." },
      ],
      finalCtaTitle: "¿LISTO PARA GANAR?",
      finalCtaBody: "Es gratis unirse, toma 60 segundos, y no hay límite de cuánto puedes ganar.",
    },
    press: {
      pageTitle: "PRENSA Y MEDIOS",
      pageSubtitle: "Comunicados, recursos de marca y materiales para periodistas y socios que cubren ChambaNow.",
      mediaInquiries: "Consultas de medios:",
      mailingAddress: "DIRECCIÓN POSTAL:",
      releasesTitle: "COMUNICADOS DE PRENSA",
      noReleases: "Aún no hay comunicados — vuelve pronto.",
      readMore: "Leer comunicado",
      backToPress: "Volver a Prensa",
      notFound: "Comunicado no encontrado.",
      kitTitle: "KIT DE MARCA",
      kitIntro: "Todos los recursos están licenciados para uso editorial sobre ChambaNow. El logo y el banner están abajo; por favor no alteres el color naranja, la palabra-marca, ni el rayo.",
      logos: "LOGOS",
      colors: "COLORES",
      typography: "TIPOGRAFÍA",
      voice: "VOZ DE MARCA",
      downloads: "DESCARGAS",
      copied: "copiado",
      teamTitle: "FUNDADOR Y EQUIPO",
      teamIntro: "Fotografías y biografías aprobadas para uso editorial.",
      founderName: "Barry Graham",
      founderRole: "Fundador y CEO, ChambaNow",
      founderBio: "Barry Graham fundó ChambaNow para llevar al internet el estacionamiento de la ferretería — una forma más rápida y segura para que trabajadores y contratantes en Champaign-Urbana se encuentren. Se enfoca en un diseño de producto que prioriza la dignidad y el acceso bilingüe para los trabajadores que mantienen funcionando a los vecindarios.",
      founderRole_es: "Fundador y CEO, ChambaNow",
      founderQuote: "\"Cada trabajador esperando en un estacionamiento es una oportunidad perdida para una familia que necesitaba la ayuda hace una hora. ChambaNow cierra esa brecha.\"",
      downloadPhoto: "Descargar foto",
    },
    jobs: {
      title: "TRABAJOS",
      subtitle: "Trabajos por día, por contrato, temporales-a-fijos, permanentes y por diem.",
      industry: "Industria",
      employmentType: "Tipo de Empleo",
      zip: "Código Postal",
      location: "Ciudad, Estado o Código Postal", locationPlaceholder: "Ciudad, Estado o Código Postal",
      viewList: "Lista", viewMap: "Mapa", viewJob: "Ver trabajo",
      temporary: "¿Temporal?",
      any: "Cualquiera", yes: "Sí", no: "No",
      loading: "Cargando…",
      noResults: "No hay trabajos activos que coincidan con tus filtros.",
      transport: "Transporte",
      self: "Propio",
      temp: "TEMP",
      perHr: "hr", perYr: "año", perJob: "trabajo",
      day_labor: "Trabajo por Día", short_term: "Corto Plazo", contract: "Contrato",
      temp_to_hire: "Temp-a-Fijo", permanent: "Permanente", full_time: "Tiempo Completo",
      part_time: "Medio Tiempo", per_diem: "Por Diem",
      sortBy: "ORDENAR",
      sortDistance: "Distancia",
      sortRecent: "Más Recientes",
      sortingFrom: "Ordenado por distancia desde el ZIP",
      enterZipForDistance: "Ingresa un ZIP en el panel de filtros para ordenar por distancia.",
      zipPlaceholder: "ej. 61820",
      search: "Buscar",
      searchPlaceholder: "ej. soldador, almacén, chofer",
      zipHelp: "Se usa como punto de partida para distancia y radio.",
      radius: "Radio de búsqueda",
      radiusAny: "Cualquier distancia",
      radiusWithin: "Dentro de {n} mi",
      radiusNote: "Mostrando empleos de ChambaNow dentro de {n} mi de {zip}, luego empleos de socios cercanos.",
      applyFilters: "Aplicar filtros",
      applyFiltersAgain: "Actualizar resultados",
      clearFilters: "Limpiar filtros",
      milesAway: "mi de distancia",
      partnerBadge: "Socio de ChambaNOW",
      externalApply: "Ver en el sitio del socio",
      partnerSectionTitle: "Más empleos de nuestros socios",
      partnerHint: "Listados externos — postularás en el sitio del socio.",
      partnerSectionLoading: "Buscando más empleos de nuestros socios cerca de ti — esto puede tardar unos segundos…",
      partnerNone: "No se encontraron empleos de socios cerca por ahora. Prueba un radio más amplio u otra zona.",
      partnerApply: "Postular en el sitio del socio",
      partnerAbout: "Sobre este puesto",
      partnerNote: "Este es un listado externo de nuestra red de socios. Al postular irás a la publicación original para completar tu solicitud.",
      partnerVia: "Publicado vía",
      partnerBack: "Volver a empleos",
      partnerExpired: "Este listado del socio ya no está disponible.",
      partnerBrowseAll: "Ver todos los empleos",
      partnerNotFound: "Este listado del socio ya no está disponible.",
      partnerLoading: "Cargando listado…",
      partnerListApply: "Postular",
      partnerSignIn: "Inicia sesión para postular",
      partnerResponsibilities: "Lo que harás",
      partnerSkills: "Habilidades útiles",
      partnerPay: "Pago y compensación",
      partnerLocationHeading: "Trabajar en esta zona",
      partnerHowToApply: "Cómo postular en ChambaNow",
      partnerFaq: "Preguntas frecuentes",
      partnerRelated: "Empleos de socios similares",
      partnerShare: "Compartir",
      partnerCopied: "¡Enlace copiado!",
      partnerShareThis: "Comparte este trabajo",
    },
    cityJobs: {
      browseByCity: "EXPLORAR POR CIUDAD",
      eyebrow: "CHAMBANOW · CIUDAD",
      heroPrefix: "Trabajos de Jornalero y Oficios Especializados en",
      postJobCta: "Publicar trabajo (Hirer Plus)",
      findWorkersCta: "Buscar trabajadores",
      browseJobsCta: "Ver trabajos abiertos",
      workerSignupCta: "Regístrate para ser contratado",
      hiringLink: "¿Estás contratando? Publica gratis",
      openJobs: "Trabajos disponibles",
      activeJob: "trabajo activo",
      activeJobs: "trabajos activos",
      empty: "Aún no hay trabajos activos en {city}. Sé el primero en publicar — los trabajadores de esta ciudad ven las nuevas publicaciones al instante.",
      nearbyTitle: "OTRAS CIUDADES CONTRATANDO",
      loadMore: "Ver más",
      nearbySubtitle: "Salta a otra ciudad con publicaciones activas en ChambaNow.",
      allJobs: "Todos los trabajos",
      jobsInPrefix: "Empleos en",
      browseAllJobs: "Ver todos los trabajos",
      notFoundTitle: "CIUDAD AÚN NO EN CHAMBANOW",
      notFoundBody: "Aún no se han publicado trabajos en esta ciudad. Las páginas de ciudad aparecen automáticamente en cuanto un contratante publica un trabajo allí.",
    },
    cityDir: {
      eyebrow: "DIRECTORIO DE CIUDADES",
      title: "Jornaleros y Trabajadores de Oficios en Cada Ciudad",
      subtitle: "Explora las 1,000 ciudades más grandes de EE. UU. Encuentra trabajos de jornalero o contrata trabajadores disponibles cerca de ti — publica trabajos ilimitados gratis por 30 días, cancela cuando quieras.",
      loading: "Cargando ciudades…",
      jobsLink: "Trabajos",
      hireLink: "Contratar",
      searchPlaceholder: "Busca una ciudad o estado…",
      noResults: "Ninguna ciudad coincide con tu búsqueda.",
      cityCount: "ciudades",
    },
    hireCity: {
      eyebrow: "CONTRATAR TRABAJADORES",
      heroPrefix: "Contrata Jornaleros y Trabajadores de Oficios en",
      heroSuffix: "Disponibles Hoy",
      subtitle: "Publica tu trabajo gratis y conéctate con trabajadores de oficios y mano de obra disponibles en {city}. Sin comisiones de agencia — negocia las tarifas directamente.",
      postFree: "Publicar trabajo — Gratis",
      postFreeNote: "Publica trabajos ilimitados gratis por 30 días. Cancela cuando quieras.",
      availableNow: "{count} disponibles ahora",
      workersReady: "trabajadores listos en {city}",
      noWorkers: "Sé el primero en contratar aquí",
      noWorkersBody: "Publica tu trabajo gratis y avisaremos a los trabajadores de {city} en cuanto esté activo.",
      topSkills: "Habilidades solicitadas",
      availableWorkers: "Trabajadores disponibles",
      anonNote: "Las identidades están protegidas. Regístrate gratis para ver perfiles y contactar trabajadores.",
      yrsExp: "años",
      ownTransport: "Transporte",
      perHr: "/hr",
      signupToContact: "Regístrate para contactar",
      browseJobs: "Ver trabajos en {city}",
      howTitle: "Cómo funciona contratar",
      step1: "Publica tu trabajo gratis en 60 segundos",
      step2: "Los trabajadores disponibles aplican directamente",
      step3: "Envía mensajes y contrata — tu mes gratis empieza el día que te registras",
      ctaBottom: "¿Listo para contratar en {city}?",
      loading: "Cargando…",
    },
    shareProfile: {
      title: "COMPARTE TU PERFIL",
      subtitle: "Publica este enlace donde sea — WhatsApp, grupos de Facebook, amigos. Quien lo abra puede contratarte en ChambaNow.",
      copy: "Copiar",
      copied: "¡Copiado!",
      copyFailed: "No se pudo copiar",
      share: "Compartir",
      preview: "Vista previa",
      shareTitle: "Contrátame en ChambaNow",
      shareText: "Mira mi perfil de ChambaNow y contrátame:",
    },
    workerProfile: {
      loading: "Cargando…",
      portfolioTitle: "Portafolio de Trabajo",
      portfolioLocked: "Este trabajador tiene {n} foto(s) de portafolio. Se requiere un Pase de Contratación o Hirer Plus activo para verlas.",
      portfolioUnlockCta: "Ver planes y precios",
      reportPrompt: "¿Por qué reportas esta foto? (opcional)",
      reportThanks: "Gracias — nuestro equipo revisará esta foto.",
      metaTitleSuffix: "Disponible para contratar en ChambaNow",
      metaDesc: "Contrata a {name} en ChambaNow — mira sus habilidades, disponibilidad y contrata directamente.",
      notFoundTitle: "TRABAJADOR NO ENCONTRADO",
      notFoundBody: "Este enlace de perfil ya no está activo. Explora trabajadores y trabajos disponibles.",
      availableNow: "Disponible ahora",
      skills: "Habilidades",
      yrsExp: "años exp",
      ownTransport: "Tiene transporte",
      perHr: "/hr",
      ctaTitle: "Contrata a {name} hoy",
      ctaBody: "Los datos de contacto y los mensajes están protegidos. Crea una cuenta gratis de contratante para escribirle a {name} y empezar.",
      hireCta: "Regístrate para contratar a {name}",
      messageCta: "Enviar mensaje a {name}",
      messageTitle: "Envíale un mensaje a {name}",
      messageBody: "Inicia una conversación con {name} aquí mismo en ChambaNow — sin números de teléfono ni correos.",
      ctaNote: "Registro gratis. Publica trabajos ilimitados gratis por 30 días — cancela cuando quieras.",
      shareThisProfile: "Comparte este perfil",
      shareMessage: "Mira a {name} en ChambaNow — ¡disponible para contratar ahora!",
    },
    companyJobs: {
      eyebrow: "TRABAJOS DE LA EMPRESA",
      openings: "Puestos Disponibles",
      jobSingular: "puesto disponible",
      jobPlural: "puestos disponibles",
      emptyBody: "{company} no está contratando ahora. Vuelve pronto.",
      visitWebsite: "Visitar sitio web",
      viewJob: "Ver trabajo",
      poweredBy: "Trabajos con tecnología de ChambaNow",
      notFoundTitle: "EMPRESA NO ENCONTRADA",
      notFoundBody: "Esta página de empresa no está disponible. Explora todos los trabajos.",
      loading: "Cargando…",
    },
    shareCompany: {
      title: "COMPARTE TU PÁGINA DE TRABAJOS",
      subtitle: "Un enlace con todos tus trabajos abiertos — publícalo en tu sitio web, redes sociales o envíalo a candidatos.",
      needsName: "Agrega el nombre de tu empresa abajo y guarda para activar tu página pública de Trabajos.",
      copy: "Copiar",
      copied: "¡Copiado!",
      copyFailed: "No se pudo copiar",
      share: "Compartir",
      preview: "Vista previa",
      shareTitle: "Trabajos en nuestra empresa en ChambaNow",
      shareText: "Mira nuestros trabajos disponibles y aplica:",
      sectionTitle: "PERFIL DE EMPRESA",
      companyName: "Nombre de la empresa",
      companyNamePlaceholder: "ej. Jardinería Acme",
      companyAbout: "Sobre tu empresa",
      companyAboutPlaceholder: "Cuéntales a los candidatos sobre tu empresa (opcional)",
      companyWebsite: "Sitio web",
      companyWebsitePlaceholder: "https://tuempresa.com",
      wizardCta: "Diseña tu página de Trabajos con el asistente",
      wizardGo: "Abrir asistente",
    },
    companySetup: {
      eyebrow: "ASISTENTE DE CONFIGURACIÓN",
      title: "Crea la página de Trabajos de tu empresa",
      subtitle: "Una página de trabajos con tu marca por la que las empresas pagan miles — la tuya en 3 pasos rápidos.",
      step1Short: "Datos",
      step2Short: "Marca",
      step3Short: "Publicar",
      step1Title: "Datos de la empresa",
      step1Desc: "Cuéntales a los candidatos quién eres. Esto será el título y el enlace de tu página pública.",
      step2Title: "Hazla tuya",
      step2Desc: "Agrega tu logo y colores de marca. Mira la vista previa actualizarse en vivo.",
      step3Title: "Publica y comparte",
      step3Desc: "¡Tu página está activa! Comparte este enlace donde sea para empezar a recibir postulantes.",
      companyName: "Nombre de la empresa",
      companyNamePlaceholder: "ej. Jardinería Acme",
      companyAbout: "Sobre tu empresa",
      companyAboutPlaceholder: "Una breve introducción que verán los candidatos (opcional)",
      companyWebsite: "Sitio web",
      companyWebsitePlaceholder: "https://tuempresa.com",
      logo: "Logo de la empresa",
      uploadLogo: "Subir logo",
      remove: "Quitar",
      bgColor: "Fondo",
      textColor: "Texto",
      accentColor: "Acento",
      resetColors: "Restablecer valores",
      whereToShare: "DÓNDE COMPARTIRLA",
      shareTips: [
        "Agrégala a tu sitio web bajo un enlace de \u201CTrabajos\u201D o \u201CEstamos contratando\u201D",
        "Publícala en tus páginas de Facebook, Instagram y LinkedIn",
        "Compártela en grupos comunitarios y de vecindario",
        "Ponla en volantes, tarjetas y letreros en la obra (como código QR)",
        "Envíala por mensaje o correo directamente a los candidatos",
      ],
      copy: "Copiar",
      copied: "¡Copiado!",
      copyFailed: "No se pudo copiar",
      share: "Compartir",
      shareText: "Mira nuestros trabajos disponibles:",
      viewPage: "Ver página",
      back: "Atrás",
      next: "Siguiente",
      saving: "Guardando…",
      finish: "Listo",
      nameRequired: "Por favor ingresa el nombre de tu empresa",
      saveError: "No se pudo guardar. Inténtalo de nuevo.",
      logoTooLarge: "Esa imagen es muy grande. Prueba con una menor a 8MB.",
      logoError: "No se pudo leer la imagen.",
      livePreview: "VISTA PREVIA EN VIVO",
      previewEyebrow: "TRABAJOS DE LA EMPRESA",
      previewCompany: "Tu Empresa",
      previewOpenings: "Puestos Disponibles",
      previewJob: "Puesto",
      previewType: "Jornalero",
      previewLocation: "Austin, TX",
      previewPowered: "Con tecnología de ChambaNow",
    },
    industries: {
      construction: "Construcción", landscaping: "Jardinería", moving: "Mudanza",
      cleaning: "Limpieza", painting: "Pintura", plumbing: "Plomería",
      electrical: "Eléctrico", roofing: "Techado", warehouse: "Almacén",
      restaurant: "Restaurante / Comida", retail: "Ventas", office: "Oficina",
      delivery: "Entregas", healthcare: "Salud", hospitality: "Hotelería",
      automotive: "Automotriz", other: "Otro",
      mechanical: "Mecánico",
    },
    postJob: {
      hirerPlusBadge: "HIRER PLUS",
      title: "PUBLICAR TRABAJO",
      editTitle: "EDITAR TRABAJO",
      editSubtitle: "Actualiza tu publicación. Los cambios serán visibles para los trabajadores de inmediato.",
      saveBtn: "GUARDAR CAMBIOS",
      saving: "Guardando…",
      saved: "Trabajo guardado",
      subtitle: "Los trabajadores verán esto en el feed de trabajos. Los campos requeridos aparecerán en el formulario de aplicación.",
      plusRequired: "Se requiere una suscripción Hirer Plus",
      plusRequiredTitle: "PLUS REQUERIDO",
      plusRequiredDesc: "Publicar trabajos es una función de Hirer Plus. Suscríbete por $29.99/mes.",
      seePricing: "VER PRECIOS",
      freeFirstBadge: "GRATIS POR 30 DÍAS",
      freeFirstNote: "Publica trabajos ilimitados gratis por 30 días — cancela cuando quieras.",
      usedFreePostTitle: "MES GRATIS TERMINADO",
      usedFreePostDesc: "Tu mes gratis terminó. Suscríbete a Hirer Plus para seguir publicando trabajos y desbloquear el contacto con postulantes.",
      loading: "Cargando…",
      jobTitle: "Título del Trabajo",
      jobTitlePlaceholder: "ej. Limpieza de patio trasero (2 días)",
      description: "Descripción",
      descriptionPlaceholder: "¿Qué debe hacer el trabajador? ¿Horas? ¿Equipo?",
      markTemporary: "Marcar como trabajo temporal",
      rateType: "Tipo de Tarifa",
      rateHourly: "Por Hora", rateJob: "Trabajo Total", rateSalary: "Salario Anual",
      rateAmount: "Tarifa ($)",
      duration: "Duración (horas)",
      city: "Ciudad",
      provideTransport: "Yo proveo el transporte",
      customQuestions: "Preguntas Personalizadas (opcional)",
      questionPlaceholder: "ej. ¿Traes tus propias herramientas?",
      remove: "QUITAR", add: "Añadir",
      posting: "Publicando...", post: "PUBLICAR TRABAJO",
      posted: "Trabajo publicado",
      failed: "Error al publicar",
    },
    myJobs: {
      title: "PANEL DE EMPLEOS",
      postBtn: "PUBLICAR TRABAJO",
      loading: "Cargando…",
      noJobs: "Aún no has publicado trabajos.",
      applies: "APLICAN",
      statusActive: "ACTIVO",
      statusPaused: "PAUSADO",
      statusEnded: "TERMINADO",
      viewApps: "Ver Solicitudes",
      edit: "Editar",
      pause: "Pausar",
      resume: "Reanudar",
      endTitle: "¿POR QUÉ VAS A TERMINAR ESTE TRABAJO?",
      endHelper: "Esto nos ayuda a mejorar ChambaNow. (Un clic — no necesitas escribir.)",
      endReasonHired: "Contraté a alguien por ChambaNow",
      endReasonExternal: "Contraté a alguien fuera de la app",
      endReasonTooFew: "No hubo suficientes solicitantes",
      endReasonOther: "Otro motivo",
      endNotePlaceholder: "¿Algo más que quieras compartir? (opcional)",
      endConfirmBtn: "TERMINAR TRABAJO",
      endCancelBtn: "Cancelar",
      end: "Terminar",
      duplicate: "Duplicar",
      duplicated: "Trabajo duplicado — edita la nueva copia",
      ended: "Trabajo terminado",
      paused: "Trabajo pausado",
      resumed: "Trabajo reanudado",
      confirmEnd: "¿Terminar este trabajo permanentemente? Aún podrás duplicarlo, pero no podrás reactivarlo.",
      ofExpiry: "Vence",
      duplicatedFrom: "Duplicado de otro trabajo",
    },
    apply: {
      back: "Atrás",
      title: "Aplicaciones",
      loading: "Cargando…",
      noApps: "Aún no hay aplicaciones.",
      ownTransport: "Transporte propio",
      needsTransport: "Necesita transporte",
      yrsExp: "años exp",
      resume: "Currículum",
      reply: "RESPONDER",
      statusSubmitted: "enviada",
      statusReviewed: "revisada",
      statusHired: "contratado",
      statusRejected: "rechazada",
      lockedBadge: "BLOQUEADO",
      lockedTitle: "¡Tienes postulantes!",
      lockedBody: "Suscríbete a Hirer Plus para desbloquear nombres, contacto, currículums y mensajes.",
      lockedCta: "Desbloquear con Hirer Plus",
    },
    threadExtra: {
      waitingHirer: "⏳ Esperando que el contratante revise tu aplicación y responda",
      transportProvided: "Transporte incluido",
      transportSelf: "El trabajador arregla el transporte",
      sendFailed: "Falló el envío",
      offerFailed: "No se pudo enviar la oferta",
      respondFailed: "No se pudo responder",
      couldNotLoad: "No se pudo cargar",
      noMessages: "Aún no hay mensajes — ¡saluda!",
      remindWorker: "Enviar recordatorio",
      reminderSent: "Recordatorio enviado al trabajador por correo.",
      reminderRateLimited: "Ya se recordó en las últimas 24 horas.",
      reminderFailed: "No se pudo enviar el recordatorio",
    },
    jobDetail: {
      back: "Atrás",
      loading: "Cargando…",
      notFoundTitle: "Trabajo ya no disponible",
      notFoundBody: "Esta oferta de trabajo ha expirado o fue eliminada.",
      loadErrorTitle: "No se pudo cargar este trabajo",
      loadErrorBody: "Algo salió mal. Inténtalo de nuevo.",
      retry: "Reintentar",
      browseAll: "Ver todos los trabajos",
      moreInCity: "Más trabajos en",
      relatedTitle: "Trabajos relacionados",
      seeAllIn: "Ver todos los trabajos en",
      share: "Compartir",
      shareCopied: "¡Enlace copiado!",
      shareThisJob: "Comparte este trabajo",
      temporary: "TEMPORAL",
      transportProvided: "Transporte incluido",
      selfTransport: "Transporte propio",
      perHr: "hr", perYr: "año", perJob: "trabajo",
      applyNow: "APLICAR AHORA",
      signInToApply: "INICIAR SESIÓN PARA APLICAR",
      hirerViewing: "Estás viendo esto como contratante — cambia a una cuenta de trabajador para aplicar.",
      testJob: "TRABAJO DE PRUEBA",
      testJobBadge: "TRABAJO DE PRUEBA",
      testJobSignIn: "Inicia sesión para ver trabajos activos actuales →",
      testJobBrowse: "Ver trabajos activos actuales →",
      applyTitle: "Aplicar",
      applyIntro: "Tu información de perfil se enviará con esta aplicación. Añade una nota corta y un currículum opcional.",
      sendingAs: "Enviando como",
      coverNote: "Nota de presentación (opcional)",
      coverPlaceholder: "Por qué eres una buena opción...",
      resumeTitle: "Currículum / Certificaciones (opcional)",
      useProfileResume: "Incluir mi currículum",
      uploading: "Subiendo…",
      attachDifferent: "Adjuntar otro archivo",
      attachResume: "Adjuntar currículum",
      uploadResumeForApproval: "Subir currículum para aprobación",
      resumeApprovalHint: "ChambaNOW revisa cada currículum. El tuyo se comparte con el contratante solo después de ser aprobado.",
      resumeApprovedNote: "Aprobado — compartido con el contratante.",
      resumePendingNote: "Pendiente de revisión de ChambaNOW — se compartirá con el contratante una vez aprobado.",
      resumeRejectedNote: "Tu último currículum no fue aprobado. Sube uno nuevo para revisión.",
      resumeUploadedForReview: "Currículum subido — lo revisaremos pronto.",
      resumeHint: "Solo PDF · Máx 5 MB · Los datos de contacto se ocultan a los contratantes.",
      resumeAttached: "Currículum adjuntado.",
      uploadFailed: "Error al subir",
      sending: "Enviando...",
      sendApp: "ENVIAR APLICACIÓN",
      sentSuccess: "Aplicación enviada. El contratante responderá por chat.",
      sendError: "Falló",
      badType: "El currículum debe ser PDF.",
      tooBig: "Archivo muy grande. Máx 5 MB.",
    },
    pricing: {
      badge: "ELIGE TU PLAN",
      heroTitle: "CONTRATA A TU MANERA",
      heroSubtitle: "Los nuevos contratantes reciben una prueba gratis de 30 días de Hirer Plus — cancela cuando quieras. Publica trabajos ilimitados, luego mantén Plus por $29.99/mes — o compra un Pase de Trabajo de 48 Horas para contratar en un solo trabajo, extensible antes de que termine.",
      passName: "Pase de Trabajo de 48 Horas",
      passPer: "/ 48h · un trabajo",
      passDesc: "48 horas de acceso para contratar en un trabajo — busca, contacta y revisa postulantes. Extiéndelo antes de que termine para seguir.",
      passFeatures: [
        "Un trabajo, 48 horas de acceso para contratar",
        "Busca, contacta y revisa postulantes de ese trabajo",
        "Extiende por 48 horas más antes de que termine",
        "Sin suscripción — mejora a Hirer Plus cuando quieras",
      ],
      passBtn: "OBTENER PASE DE 48 HORAS",
      plusName: "Hirer Plus",
      plusPer: "/ mes",
      plusDesc: "Para contratantes activos que necesitan llenar varios puestos en trabajos por día, contrato y tiempo completo.",
      plusFeatures: [
        "Publica trabajos ILIMITADOS para que apliquen los trabajadores",
        "Contacta y escribe a todos los postulantes",
        "Tu propia página de Trabajos de empresa — compártela en tu sitio web",
        "Día, contrato, temp-a-fijo, permanente, tiempo completo, per-diem",
        "Acceso ilimitado a disponibilidad en vivo — sin pase necesario",
        "Recibe aplicaciones + formularios personalizados",
        "Todas las industrias: construcción, jardinería, limpieza, trabajo general y más",
        "Cancela cuando quieras",
      ],
      recommended: "RECOMENDADO",
      manageSub: "ADMINISTRAR SUSCRIPCIÓN",
      goPlus: "ACTIVAR PLUS — $29.99/MES",
      winbackTitle: "Bienvenido de nuevo — tu próximo mes es gratis 🎁",
      winbackBody: "Reactiva Hirer Plus abajo y no se te cobrará por 30 días. Se requiere una tarjeta para que tus beneficios continúen automáticamente después — cancela cuando quieras.",
      hirersOnly: "Sólo contratantes",
      failed: "Falló",
    },
};
